import { putRequest } from 'utils/request';

export const getOrdersReport = (values: { date_from: any, date_to: any }) =>
  putRequest('/api/reports/orders')(values)